import {
  Badge,
  BadgeProps,
  HStack,
  Text,
  TextProps,
  Tooltip,
} from "@chakra-ui/react";
import {
  PerformanceInfo,
  PerformanceTier,
} from "common/interfaces/KYDMarketing";

const colorSchemeForPerformanceTier = (tier: PerformanceTier) => {
  if (tier === PerformanceTier.HIGH_PERFORMANCE)
    return { bg: "green.100", color: "green.700" };
  if (tier === PerformanceTier.UNDERPERFORMING)
    return { bg: "red.100", color: "red.700" };
  if (tier === PerformanceTier.ON_TRACK)
    return { bg: "blue.100", color: "blue.700" };
  if (tier === PerformanceTier.TOO_EARLY_TO_TELL)
    return { bg: "gray.100", color: "gray.700" };
  return { bg: "gray.100", color: "gray.700" };
};

export const textForPerformanceTier = (tier: PerformanceTier) => {
  if (tier === PerformanceTier.HIGH_PERFORMANCE) return "High Performing";
  if (tier === PerformanceTier.UNDERPERFORMING) return "Underperforming";
  if (tier === PerformanceTier.ON_TRACK) return "On Track";
  if (tier === PerformanceTier.TOO_EARLY_TO_TELL) return "Too Early To Tell";
  return "Unknown";
};

/** Badge used in Campaign Detail to show only performance tier (High Performing / Underperforming). Shows finding summary as tooltip when present. Renders nothing when tier is missing. */
export function PerformanceTierBadge({
  performance,
}: {
  performance: PerformanceInfo;
}) {
  if (performance == null) return null;

  const label = textForPerformanceTier(performance.tier);
  const { bg, color } = colorSchemeForPerformanceTier(performance.tier);

  const badgeStyles: BadgeProps = {
    borderRadius: "0.625rem",
    bg,
    color,
    display: "flex",
    px: 2,
    justifyContent: "center",
    height: 4,
    alignItems: "center",
    gap: "0.625rem",
    alignSelf: "stretch",
  };

  const textStyles: TextProps = {
    fontFamily: "Work Sans",
    fontSize: "xx-small",
    fontWeight: 500,
    lineHeight: "100%",
  };

  const badge = (
    <Badge {...badgeStyles}>
      <HStack gap="0.625rem">
        <Text {...textStyles}>{label}</Text>
      </HStack>
    </Badge>
  );

  if (performance.explanation?.trim()) {
    return (
      <Tooltip label={performance.explanation} placement="top" hasArrow>
        {badge}
      </Tooltip>
    );
  }
  return badge;
}
